(() => {
  'use strict';

  const selector = [
    'a',
    'button',
    'input[type="button"]',
    'input[type="submit"]',
    '[role="button"]',
    '.shopify-payment-button__button--unbranded'
  ].join(',');

  const normalize = (value) => String(value || '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();

  const isDirectPurchaseLabel = (label) => {
    const text = normalize(label);
    return /^(buy now|buy product|buy it now)(?:\b|\s|—|-|:|·|\|)/i.test(text)
      || text === 'buy now'
      || text === 'buy product'
      || text === 'buy it now';
  };

  const labelFor = (element) => {
    if (element.matches('input')) return element.value;
    return element.getAttribute('aria-label') || element.textContent;
  };

  const markButtons = (root = document) => {
    if (!root || typeof root.querySelectorAll !== 'function') return;

    const candidates = root.matches?.(selector)
      ? [root, ...root.querySelectorAll(selector)]
      : [...root.querySelectorAll(selector)];

    candidates.forEach((element) => {
      if (
        element.matches('.shopify-payment-button__button--unbranded')
        || element.hasAttribute('data-buy-now')
        || isDirectPurchaseLabel(labelFor(element))
      ) {
        element.classList.add('purchase-cta--green');
      }
    });
  };

  const initialize = () => {
    markButtons(document);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData') {
          markButtons(mutation.target.parentElement);
          return;
        }
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) markButtons(node);
        });
      });
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      characterData: true
    });

    document.addEventListener('shopify:section:load', (event) => markButtons(event.target));
    document.addEventListener('shopify:block:select', (event) => markButtons(event.target));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
